// extracted by mini-css-extract-plugin
export default {"header":"header_header__54zHM","logo":"header_logo__QJOqa","links":"header_links__R3tCg","log_reg_links":"header_log_reg_links__bb+v4","nav_icon":"header_nav_icon__Gl5l0"};